import React from 'react';
import Skeleton from '@mui/material/Skeleton';

/**
 * @typedef {object} MultipleSkeletonsProps
 * @property {number} count
 * @property {boolean} show
 */

/**
 * @param {MultipleSkeletonsProps} props
 */
const MultipleSkeletons = props => {
  const { count, show } = props;

  if (!show) {
    return null;
  }

  return Array.from({ length: count }, (_, index) => (
    <Skeleton key={index} animation='wave' variant='rectangular' />
  ));
};

export default MultipleSkeletons;
